interface AssignmentFAQProps {
  faqs: Array<{
    question: string;
    answer: string;
  }>;
}

function AssignmentFAQ({ faqs }: AssignmentFAQProps) {
  return (
    <div className="assignment-faq-list">
      {faqs.map((faq) => (
        <details key={faq.question} className="assignment-faq-item">
          <summary>{faq.question}</summary>
          <div className="assignment-faq-answer">{faq.answer}</div>
        </details>
      ))}
    </div>
  );
}

export default AssignmentFAQ;
